import React from "react";

class FanMain extends React.Component { 
    render() {
        return (
			<svg width="319" height="319" viewBox="0 0 319 319" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="159.5" cy="159.5" r="158.5" fill="#212226"/>
			<circle cx="159.5" cy="159.5" r="159" stroke="#8A8B8D" strokeOpacity="0.5"/>
			<g opacity="0.5">
			<path opacity="0.5" d="M147.564 118.719L163.621 23.1888C160.073 23.0077 156.482 22.9544 152.87 23.0397C115.025 23.9879 81.1533 40.1938 56.9883 65.6161L127.054 132.24C132.371 125.933 139.467 121.17 147.564 118.719Z" fill="url(#paint0_linear)"/>
			<path opacity="0.5" d="M190.644 129.523L280.538 97.3033C278.961 94.1175 277.256 90.9637 275.413 87.8525C256.085 55.3022 225.4 33.6731 191.4 25.0107L167.811 117.579C176.654 119.156 184.56 123.429 190.644 129.523Z" fill="url(#paint1_linear)"/>
			<path opacity="0.5" d="M292.137 121.032L201.07 146.391C202.509 150.695 203.297 155.287 203.297 160.071C203.297 164.45 202.637 168.68 201.422 172.665L273.821 234.324C275.803 231.373 277.689 228.315 279.468 225.172C298.071 192.206 301.555 154.818 292.137 121.032Z" fill="url(#paint2_linear)"/>
			<path opacity="0.5" d="M195.361 185.023C188.904 194.123 179.027 200.622 167.584 202.614L150.174 297.005C153.349 297.143 156.545 297.186 159.774 297.101C200.262 296.078 236.2 277.603 260.589 249.048L195.361 185.023Z" fill="url(#paint3_linear)"/>
			<path opacity="0.5" d="M127.564 189.221L35.4746 220.578C36.9023 223.412 38.4366 226.225 40.0775 228.995C60.7584 263.825 94.4487 286.147 131.272 293.456L155.543 204.169C144.377 202.901 134.489 197.372 127.564 189.221Z" fill="url(#paint4_linear)"/>
			<path opacity="0.5" d="M116.889 160.071C116.889 155.405 117.635 150.908 119.01 146.7L45.7263 82.249C43.9789 84.9021 42.3061 87.6297 40.7185 90.4319C20.8154 125.71 18.2263 166.038 30.2129 201.625L120.757 177.95C118.285 172.495 116.889 166.454 116.889 160.071Z" fill="url(#paint5_linear)"/>
			</g>
			<defs>
			<linearGradient id="paint0_linear" x1="68.246" y1="80.2817" x2="154.277" y2="77.1101" gradientUnits="userSpaceOnUse">
			<stop stopColor="white" stopOpacity="0"/>
			<stop offset="1" stopColor="#C4C4C4" stopOpacity="0.5"/>
			</linearGradient>
			<linearGradient id="paint1_linear" x1="182.687" y1="64.7029" x2="235.812" y2="109.899" gradientUnits="userSpaceOnUse">
			<stop stopColor="white" stopOpacity="0"/>
			<stop offset="1" stopColor="#C4C4C4" stopOpacity="0.5"/>
			</linearGradient>
			<linearGradient id="paint2_linear" x1="252.742" y1="134.766" x2="242.435" y2="199.785" gradientUnits="userSpaceOnUse">
			<stop stopColor="white" stopOpacity="0"/>
			<stop offset="1" stopColor="#C4C4C4" stopOpacity="0.5"/>
			</linearGradient>
			<linearGradient id="paint3_linear" x1="241.961" y1="232.063" x2="161.481" y2="243.957" gradientUnits="userSpaceOnUse">
			<stop stopColor="white" stopOpacity="0"/>
			<stop offset="1" stopColor="#C4C4C4" stopOpacity="0.5"/>
			</linearGradient>
			<linearGradient id="paint4_linear" x1="133.576" y1="275.189" x2="90.7584" y2="205.017" gradientUnits="userSpaceOnUse">
			<stop stopColor="white" stopOpacity="0"/>
			<stop offset="1" stopColor="#C4C4C4" stopOpacity="0.5"/>
			</linearGradient>
			<linearGradient id="paint5_linear" x1="64.8587" y1="193.355" x2="81.5099" y2="115.65" gradientUnits="userSpaceOnUse">
			<stop stopColor="white" stopOpacity="0"/>
			<stop offset="1" stopColor="#C4C4C4" stopOpacity="0.5"/>
			</linearGradient>
			</defs>
			</svg>

        )
    }
}

export default FanMain;




